
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class MediaIcon extends Vue {
  @Prop() isDisabled!: boolean;
  @Prop() isAudio!: boolean;
  @Prop() isWhite!: boolean;

  gFill = 'none';
  rectFill = '#FFFFFF';
  pathPath = '#444444';

  mounted() {
    if (this.isWhite) {
      this.gFill = '#444444';
      this.rectFill = 'none';
      this.pathPath = '#FFFFFF';
    }
  }
}
